import { getToken } from './client';

// Aponte para outro backend com REACT_APP_BACKEND_URL no .env (ex.:
// http://localhost:8000). O padrão continua sendo o ambiente publicado,
// para não mudar o comportamento de quem já roda com ele.
const API_URL = process.env.REACT_APP_BACKEND_URL || 'https://staging-mypedidos-backend.onrender.com';

export async function uploadProductImage(file) {
  const token = getToken();
  const form = new FormData();
  form.append('file', file);

  const response = await fetch(`${API_URL}/establishments/me/uploads/product-image`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    body: form,
  });

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(data?.message || 'Erro ao enviar a imagem.');
  }

  return data.url;
}

export async function uploadEstablishmentLogo(file) {
  const token = getToken();
  const form = new FormData();
  form.append('file', file);

  const response = await fetch(`${API_URL}/establishments/me/uploads/logo`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    body: form,
  });

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(data?.message || 'Erro ao enviar a imagem.');
  }

  return data.url;
}

// Único upload que aceita vídeo (além de imagem/GIF) — o backend decide o que
// aceitar; aqui só repassamos o arquivo e deixamos o erro do servidor (422)
// subir como mensagem amigável se o formato for rejeitado.
export async function uploadEstablishmentBanner(file) {
  const token = getToken();
  const form = new FormData();
  form.append('file', file);

  const response = await fetch(`${API_URL}/establishments/me/uploads/banner`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    body: form,
  });

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(data?.message || 'Erro ao enviar o banner.');
  }

  return data.url;
}
